import { useMutation } from "react-query";
import { updateEmployeeReportsTo } from "../../../../../actions/Utilities/EmployeeReportsTo";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  editStateEmployeeReportsTo,
  employeeReportsToReFetching,
} from "../atoms/atoms";
import { IEmployeeReportsTo } from "../types";
import { toast } from "components/toastNotification";

const useEditEmployeeReportsTo = () => {
  // return useMutation(updateEmployeeReportsTo);
  
  const setActionEditState = useSetRecoilState(editStateEmployeeReportsTo);
  const [isReFetching, setIsReFetching] = useRecoilState(
    employeeReportsToReFetching
  );

  const { mutate } = useMutation(
    (newData: IEmployeeReportsTo) => updateEmployeeReportsTo(newData),
    {
      onSuccess: (res) => {

        if (typeof res == "object") {
          toast.fire(
            "Updating Employee Reports To failed",
            `${res.Message}`,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Employee Reports To Updated Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Employee Reports To Updated Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Updating Employee Reports To failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Updating Employee Reports To failed ",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Updating Employee Reports To failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire(
                "Updating Employee Reports To failed",
                `${res}`,
                "error"
              );
          }
        }
        setActionEditState(false);
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire(
          "Update Employee Reports To failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );
  return mutate;
};

export default useEditEmployeeReportsTo;